import React from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { FaHandPointRight, FaCheckCircle, FaLaptopCode, FaCheck } from 'react-icons/fa';

// Primary Brand Color
const PRIMARY_BLUE = '#0056d2';

export default function Home() {
    const { openDemoModal } = useOutletContext();

    const demoHighlights = [
        'Personalized academy needs analysis',
        'Deep dive into automated fee collection',
        'Live Q&A with a product specialist',
        'Mobile app features walkthrough'
    ];

    return (
        <div className="bg-light">

            {/* HERO SECTION - UI + SEO Optimized */}
            <section className="py-5 py-lg-6 bg-white">
                <div className="container">
                    <div className="row align-items-center">

                        {/* LEFT CONTENT */}
                        <div className="col-lg-7 mb-5 mb-lg-0 pe-lg-4">

                            {/* SEO Heading */}
                            <h1 className="display-5 fw-bold mb-3 text-dark lh-base">
                                Aadhav Academy <br />
                                <span style={{ color: PRIMARY_BLUE }}>
                                    Academy & Sports Management Software
                                </span>
                            </h1>

                            {/* SEO Subheading */}
                            <h2 className="h6 text-secondary fw-semibold mb-3">
                                The All-in-One App for Sports & Educational Academies
                            </h2>

                            {/* Brand Description */}
                            <p className="text-dark fs-6 mb-4">
                                Digitize your academy operations with automated fee collection, attendance tracking,
                                tournament registration, student progress reports, and mobile communication — all in one platform.
                            </p>

                            {/* Bullet Feature Highlights */}
                            <div className="d-flex flex-wrap gap-2 mb-4">
                                <span className="badge rounded-pill bg-success-subtle text-success px-3 py-2 border">
                                    ✔ Online Fee Collection
                                </span>
                                <span className="badge rounded-pill bg-primary-subtle text-primary px-3 py-2 border">
                                    ✔ Attendance Tracking
                                </span>
                                <span className="badge rounded-pill bg-info-subtle text-info px-3 py-2 border">
                                    ✔ Tournament Registration
                                </span>
                                <span className="badge rounded-pill bg-warning-subtle text-warning px-3 py-2 border">
                                    ✔ Mobile App for Coaches & Parents
                                </span>
                            </div>

                            <p className="small fw-medium text-muted mb-4">
                                Trusted by growing academies across India 💙
                                Boost productivity & maximize academy revenue 🚀
                            </p>

                            {/* Internal SEO Navigation Links */}
                            <div className="d-flex flex-wrap gap-3">
                                <Link to="/features" className="btn btn-primary fw-bold shadow-sm">
                                    Explore Features →
                                </Link>
                                <Link to="/pricing" className="btn btn-outline-dark fw-semibold">
                                    View Pricing
                                </Link>
                                <Link to="/tournament" className="btn btn-outline-success fw-semibold">
                                    Register Tournament
                                </Link>
                            </div>
                        </div>

                        {/* DEMO CTA CARD */}
                        <div className="col-lg-5">
                            <div
                                className="p-4 rounded-4 shadow-lg bg-white border border-2"
                                style={{ borderColor: PRIMARY_BLUE }}
                            >
                                <h5 className="fw-bold mb-3 text-center" style={{ color: PRIMARY_BLUE }}>
                                    <FaLaptopCode className="me-2" /> Schedule a Free Live Demo
                                </h5>

                                <p className="text-center text-muted small mb-4">
                                    30-minute tailored walkthrough with our product expert.
                                </p>

                                <button
                                    className="btn text-white fw-bold w-100 py-3 shadow"
                                    style={{ background: PRIMARY_BLUE }}
                                    onClick={openDemoModal}
                                >
                                    <FaHandPointRight className="me-2" /> Book Demo Now
                                </button>

                                <p className="text-center text-muted small mt-3 mb-3">
                                    No credit card required — Quick onboarding
                                </p>

                                <hr />

                                <ul className="list-unstyled small">
                                    {demoHighlights.map((text, index) => (
                                        <li key={index} className="d-flex align-items-start mb-2 text-dark">
                                            <FaCheck className="text-success me-2 mt-1" size={14} />
                                            {text}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}
